import type { AppRouteRecordRaw, AppRouteModule } from '/@/router/types';
import {
  HomeRoute,
  PAGE_NOT_FOUND_ROUTE,
  PAGE_UPDATE_ROUTE,
  QuestionnaireRoute,
  QuestionnaireIpiRoute,
  QuestionnaireCpiRoute,
  REDIRECT_ROUTE,
  QuestionnaireInfoRoute,
  ProductInfoRoute,
} from '/@/router/routes/basic';
import helpRoutes from './modules/help';
import market from './modules/market';
import metf from './modules/metf';
import brand from './modules/brand';
import sysNotification from './modules/sysNotification';
import { PageEnum } from '/@/enums/pageEnum';
import { t } from '@mcex/locale';

// import.meta.globEager() 直接引入所有的模块 Vite 独有的功能
const modules = import.meta.globEager(['./modules/**/*.ts', './modules/**/*.tsx']);
const routeModuleList: AppRouteModule[] = [];

// 加入到路由集合中
Object.keys(modules).forEach((key) => {
  const mod = modules[key].default || {};
  const modList = Array.isArray(mod) ? [...mod] : [mod];
  routeModuleList.push(...modList);
});

export const asyncRoutes = [PAGE_NOT_FOUND_ROUTE, ...routeModuleList];

// 根路由
export const RootRoute: AppRouteRecordRaw = {
  path: '/',
  name: 'Root',
  redirect: PageEnum.HOME,
  meta: {
    title: 'Root',
  },
};

export const LoginRoute: AppRouteRecordRaw = {
  path: '/login',
  name: 'Login',
  component: () => import('/@/views/sys/login/Login.vue'),
  meta: {
    title: t('routes.basic.login'),
  },
};

// Basic routing without permission
// 不需要权限控制的初始路由
export const basicRoutes = [
  HomeRoute,
  LoginRoute,
  RootRoute,
  REDIRECT_ROUTE,
  PAGE_NOT_FOUND_ROUTE,
  PAGE_UPDATE_ROUTE,
  QuestionnaireRoute,
  QuestionnaireIpiRoute,
  QuestionnaireCpiRoute,
  QuestionnaireInfoRoute,
  helpRoutes,
  market,
  metf,
  ProductInfoRoute,
  brand,
  sysNotification,
];
